export default {
  "9142C": [
    {
      from_internal: "requestorPocLastName",
      to: "c1_poc_last",
    },
    {
      from_internal: "requestorPocFirstName",
      to: "c2_poc_first",
    },
    {
      from_internal: "requestorPocMiddleName",
      to: "c3_poc_middle",
    },
    {
      from_internal: "requestorPocJobTitle",
      to: "c4_poc_title",
    },
    {
      from_internal: "requestorPocAddr1",
      to: "c5_poc_address_1",
    },
    {
      from_internal: "requestorPocAddr2",
      to: "c6_poc_address_2",
    },
    {
      from_internal: "requestorPocCity",
      to: "c7_poc_city",
    },
    {
      from_internal: "requestorPocState",
      to: "c8_poc_state_id",
      type: "state",
    },
    {
      from_internal: "requestorPocPostalCode",
      to: "c9_poc_zip",
    },
    {
      from_internal: "requestorPocCountry",
      to: "c10_poc_country_id",
    },
    {
      from_internal: "requestorPocProvince",
      to: "c11_poc_province",
    },
    {
      from_internal: "requestorPocPhone",
      to: "c12_poc_phone",
    },
    {
      from_internal: "requestorPocPhoneExt",
      to: "c13_poc_phone_ext",
    },
    {
      from_internal: "requestorPocEmail",
      to: "c14_poc_email",
    },
    {
      from_internal: "attyRepresentType",
      to: "d1_agent_type_id",
    },
    {
      from_internal: "attyLastname",
      to: "d2_agent_last",
    },
    {
      from_internal: "attyFirstname",
      to: "d3_agent_first",
    },
    {
      from_internal: "attyMiddlename",
      to: "d4_agent_middle",
    },
    {
      from_internal: "attyAddr1",
      to: "d5_agent_address_1",
    },
    {
      from_internal: "attyAddr2",
      to: "d6_agent_address_2",
    },
    {
      from_internal: "attyCity",
      to: "d7_agent_city",
    },
    {
      from_internal: "attyState",
      to: "d8_agent_state_id",
      type: "state",
    },
    {
      from_internal: "attyPostcode",
      to: "d9_agent_zip",
    },
    {
      from_internal: "attyCountry",
      to: "d10_agent_country_id",
    },
    {
      from_internal: "attyProvince",
      to: "d11_agent_province",
    },
    {
      from_internal: "attyPhone",
      to: "d12_agent_phone",
    },
    {
      from_internal: "attyPhoneext",
      to: "d13_agent_phone_ext",
    },
    {
      from_internal: "attyEmail",
      to: "d14_agent_email",
    },
    {
      from_internal: "attyBizname",
      to: "d15_agent_firm_name",
    },
    {
      from_internal: "attyFein",
      to: "d16_agent_firm_fein",
    },
  ],
  "9142B": [
    {
      from_internal: "attyRepresentType",
      to: "attyRepresentType",
    },
    {
      from_internal: "attyLastname",
      to: "attyLastname",
    },
    {
      from_internal: "attyFirstname",
      to: "attyFirstname",
    },
    {
      from_internal: "attyMiddlename",
      to: "attyMiddlename",
    },
    {
      from_internal: "attyAddr1",
      to: "attyAddr1",
    },
    {
      from_internal: "attyAddr2",
      to: "attyAddr2",
    },
    {
      from_internal: "attyCity",
      to: "attyCity",
    },
    {
      from_internal: "attyState",
      to: "attyState",
      type: "state",
    },
    {
      from_internal: "attyPostcode",
      to: "attyPostcode",
    },
    {
      from_internal: "attyCountry",
      to: "attyCountry",
    },
    {
      from_internal: "attyProvince",
      to: "attyProvince",
    },
    {
      from_internal: "attyPhone",
      to: "attyPhone",
    },
    {
      from_internal: "attyPhoneext",
      to: "attyPhoneext",
    },
    {
      from_internal: "attyEmail",
      to: "attyEmail",
    },
    {
      from_internal: "attyBizname",
      to: "attyBizname",
    },
    {
      from_internal: "attyFein",
      to: "attyFein",
    },
    {
      from_internal: "requestorPocLastName",
      to: "emppocLastname",
    },
    {
      from_internal: "requestorPocFirstName",
      to: "emppocFirstname",
    },
    {
      from_internal: "requestorPocMiddleName",
      to: "emppocMiddlename",
    },
    {
      from_internal: "requestorPocJobTitle",
      to: "emppocJobtitle",
    },
    {
      from_internal: "requestorPocAddr1",
      to: "emppocAddr1",
    },
    {
      from_internal: "requestorPocAddr2",
      to: "emppocAddr2",
    },
    {
      from_internal: "requestorPocCity",
      to: "emppocCity",
    },
    {
      from_internal: "requestorPocState",
      to: "emppocState",
      type: "state",
    },
    {
      from_internal: "requestorPocPostalCode",
      to: "emppocPostcode",
    },
    {
      from_internal: "requestorPocCountry",
      to: "emppocCountry",
    },
    {
      from_internal: "requestorPocProvince",
      to: "emppocProvince",
    },
    {
      from_internal: "requestorPocPhone",
      to: "emppocPhone",
    },
    {
      from_internal: "requestorPocPhoneExt",
      to: "emppocPhoneext",
    },
    {
      from_internal: "requestorPocEmail",
      to: "emppocEmail",
    },
  ],
  "9035": [
    {
      from_internal: "pwdWageRate",
      to: "_section_f_f11_prevailing_wage",
    },
    {
      from_internal: "pwdUnitOfPay",
      to: "_section_f_f11a_prevailing_wage_per",
      type: "per",
    }
  ],
};
